import { useLocalizedWorkingStepLabel } from 'components/Localization/useLocalizedWorkingStepLabel'
import React from 'react'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ReactComponent as Anodising } from '_icons/workingSteps/anodising-sm.svg'
import { ReactComponent as Assembling } from '_icons/workingSteps/assembling-sm.svg'
import { ReactComponent as HemmingIcon } from '_icons/workingSteps/bend-closed_sm.svg'
import { ReactComponent as BlastingIcon } from '_icons/workingSteps/blasting-sm.svg'
import { ReactComponent as BoltPressing } from '_icons/workingSteps/bolt_pressing-sm.svg'
import { ReactComponent as CertifyIcon } from '_icons/workingSteps/cf_certify_certify-sm.svg'
import { ReactComponent as DrawingIcon } from '_icons/workingSteps/cf_draw_draw-sm.svg'
import { ReactComponent as TransportIcon } from '_icons/workingSteps/cf_transport_transport-sm.svg'
import { ReactComponent as CounterSinkingIcon } from '_icons/workingSteps/countersinking-sm.svg'
import { ReactComponent as Deburring } from '_icons/workingSteps/deburring-sm.svg'
import { ReactComponent as DieSinkingIcon } from '_icons/workingSteps/die_sinking_sm.svg'
import { ReactComponent as Drilling } from '_icons/workingSteps/drilling-sm.svg'
import { ReactComponent as EdgeMilling } from '_icons/workingSteps/edge_milling-sm.svg'
import { ReactComponent as EdgeTrimming } from '_icons/workingSteps/edge_trimming-sm.svg'
import { ReactComponent as EngravingIcon } from '_icons/workingSteps/engraving-sm.svg'
import { ReactComponent as FoldingIcon } from '_icons/workingSteps/folding-sm.svg'
import { ReactComponent as LevelTensioning } from '_icons/workingSteps/level_tensioning-sm.svg'
import { ReactComponent as MillingIcon } from '_icons/workingSteps/milling-sm.svg'
import { ReactComponent as NitridingIcon } from '_icons/workingSteps/nitriding_sm.svg'
import { ReactComponent as NutPressing } from '_icons/workingSteps/nut_pressing-sm.svg'
import { ReactComponent as OrderPickingIcon } from '_icons/workingSteps/order_picking-sm.svg'
import { ReactComponent as PackagingIcon } from '_icons/workingSteps/packaging-sm.svg'
import { ReactComponent as PicklingPassivating } from '_icons/workingSteps/pickling_passivating-sm.svg'
import { ReactComponent as PlateCuttingIcon } from '_icons/workingSteps/plate_cutting-sm.svg'
import { ReactComponent as PlateShearing } from '_icons/workingSteps/plate_shearing-sm.svg'
import { ReactComponent as Polishing } from '_icons/workingSteps/polishing-sm.svg'
import { ReactComponent as PowderCoating } from '_icons/workingSteps/powder_coating-sm.svg'
import { ReactComponent as ProgrammingIcon } from '_icons/workingSteps/programming-sm.svg'
import { ReactComponent as Punching } from '_icons/workingSteps/punching-sm.svg'
import { ReactComponent as PurchasingIcon } from '_icons/workingSteps/purchasing-sm.svg'
import { ReactComponent as RobotStudWeldingIcon } from '_icons/workingSteps/robot_stud_welding_sm.svg'
import { ReactComponent as RobotWeldingIcon } from '_icons/workingSteps/robot_welding_sm.svg'
import { ReactComponent as Rolling } from '_icons/workingSteps/rolling-sm.svg'
import { ReactComponent as SawingIcon } from '_icons/workingSteps/sawing-sm.svg'
import { ReactComponent as StudWelding } from '_icons/workingSteps/stud_welding-sm.svg'
import { ReactComponent as ThreadTapping } from '_icons/workingSteps/thread_tapping-sm.svg'
import { ReactComponent as TubeBending } from '_icons/workingSteps/tube_bending-sm.svg'
import { ReactComponent as TubeOrProfileCuttingIcon } from '_icons/workingSteps/tube_or_profile_cutting-sm.svg'
import { ReactComponent as TuringIcon } from '_icons/workingSteps/turning-sm.svg'
import { ReactComponent as UndefinedIcon } from '_icons/workingSteps/undefined-sm.svg'
import { ReactComponent as WeldGrindingIcon } from '_icons/workingSteps/weld-grinding-sm.svg'
import { ReactComponent as Welding } from '_icons/workingSteps/welding-sm.svg'
import { ReactComponent as WireErosionIcon } from '_icons/workingSteps/wire_erosion_sm.svg'
import { ReactComponent as ZincPlating } from '_icons/workingSteps/zinc_plating-sm.svg'
import { ReactComponent as CleaningIcon } from '_icons/workingSteps/cleaning_sm.svg'
import { ReactComponent as DipCoatingIcon } from '_icons/workingSteps/dip_coating_sm.svg'
import { ReactComponent as FlowDrillingIcon } from '_icons/workingSteps/flow_drilling_sm.svg'
import { ReactComponent as FoilingIcon } from '_icons/workingSteps/foiling_sm.svg'
import { ReactComponent as HoleProtectioningIcon } from '_icons/workingSteps/hole_protectioning_sm.svg'
import { ReactComponent as OperatingIcon } from '_icons/workingSteps/operating_sm.svg'
import { ReactComponent as QualityControllingIcon } from '_icons/workingSteps/quality_controlling_sm.svg'
import { ReactComponent as ResearchingIcon } from '_icons/workingSteps/researching_sm.svg'
import { ReactComponent as VibratoryDeburringIcon } from '_icons/workingSteps/vibratory_deburring_sm.svg'

type WorkingStepIconSvgProps = {
  workingStepType: WorkingStepType
  attributes?: React.SVGProps<SVGSVGElement>
  disableTitle?: boolean
  title?: string
  className?: string
}

const _WorkingStepIconSvg = (props: WorkingStepIconSvgProps, ref) => {
  const getAttributes = (
    props: WorkingStepIconSvgProps,
    ref: string,
    workinStepType: WorkingStepType
  ) => {
    const svgTitle = props.title
      ? props.title
      : !props.disableTitle && getLocalizedWorkingStep(workinStepType)

    return {
      ...props.attributes,
      className: `icon ${props.className || ''}`,
      ref,
      title: svgTitle,
    }
  }

  const { getLocalizedWorkingStep } = useLocalizedWorkingStepLabel()

  switch (props.workingStepType) {
    case WorkingStepType.SheetCutting:
      return (
        <PlateCuttingIcon
          {...getAttributes(props, ref, WorkingStepType.SheetCutting)}
        />
      )

    case WorkingStepType.Sawing:
      return (
        <SawingIcon {...getAttributes(props, ref, WorkingStepType.Sawing)} />
      )

    case WorkingStepType.SheetBending:
      return (
        <FoldingIcon
          {...getAttributes(props, ref, WorkingStepType.SheetBending)}
        />
      )

    case WorkingStepType.CounterSinking:
      return (
        <CounterSinkingIcon
          {...getAttributes(props, ref, WorkingStepType.CounterSinking)}
        />
      )

    case WorkingStepType.Milling:
      return (
        <MillingIcon
          {...getAttributes(props, ref, WorkingStepType.Milling)}
          title="milling"
        />
      )

    case WorkingStepType.TubeOrProfileCutting:
      return (
        <TubeOrProfileCuttingIcon
          {...getAttributes(props, ref, WorkingStepType.TubeOrProfileCutting)}
          title="tube or profile cutting"
        />
      )

    case WorkingStepType.Turning:
      return (
        <TuringIcon {...getAttributes(props, ref, WorkingStepType.Turning)} />
      )

    case WorkingStepType.Purchasing:
      return (
        <PurchasingIcon
          {...getAttributes(props, ref, WorkingStepType.Purchasing)}
        />
      )

    case WorkingStepType.Engraving:
      return (
        <EngravingIcon
          {...getAttributes(props, ref, WorkingStepType.Engraving)}
        />
      )

    case WorkingStepType.ThreadTapping:
      return (
        <ThreadTapping
          {...getAttributes(props, ref, WorkingStepType.ThreadTapping)}
        />
      )

    case WorkingStepType.Anodising:
      return (
        <Anodising {...getAttributes(props, ref, WorkingStepType.Anodising)} />
      )

    case WorkingStepType.Assembling:
      return (
        <Assembling
          {...getAttributes(props, ref, WorkingStepType.Assembling)}
        />
      )

    case WorkingStepType.BoltPressing:
      return (
        <BoltPressing
          {...getAttributes(props, ref, WorkingStepType.BoltPressing)}
        />
      )

    case WorkingStepType.Deburring:
      return (
        <Deburring {...getAttributes(props, ref, WorkingStepType.Deburring)} />
      )

    case WorkingStepType.Drilling:
      return (
        <Drilling {...getAttributes(props, ref, WorkingStepType.Drilling)} />
      )

    case WorkingStepType.EdgeMilling:
      return (
        <EdgeMilling
          {...getAttributes(props, ref, WorkingStepType.EdgeMilling)}
        />
      )

    case WorkingStepType.EdgeTrimming:
      return (
        <EdgeTrimming
          {...getAttributes(props, ref, WorkingStepType.EdgeTrimming)}
        />
      )

    case WorkingStepType.LevelTensioning:
      return (
        <LevelTensioning
          {...getAttributes(props, ref, WorkingStepType.LevelTensioning)}
        />
      )

    case WorkingStepType.NutPressing:
      return (
        <NutPressing
          {...getAttributes(props, ref, WorkingStepType.NutPressing)}
        />
      )

    case WorkingStepType.PicklingPassivating:
      return (
        <PicklingPassivating
          {...getAttributes(props, ref, WorkingStepType.PicklingPassivating)}
        />
      )

    case WorkingStepType.SheetShearing:
      return (
        <PlateShearing
          {...getAttributes(props, ref, WorkingStepType.SheetShearing)}
        />
      )

    case WorkingStepType.Polishing:
      return (
        <Polishing {...getAttributes(props, ref, WorkingStepType.Polishing)} />
      )
      case WorkingStepType.ElectrolyticPolishing:
      return (
        <Polishing
          {...getAttributes(props, ref, WorkingStepType.ElectrolyticPolishing)}
        />
      )
    case WorkingStepType.PowderCoating:
      return (
        <PowderCoating
          {...getAttributes(props, ref, WorkingStepType.PowderCoating)}
        />
      )

    case WorkingStepType.Punching:
      return (
        <Punching {...getAttributes(props, ref, WorkingStepType.Punching)} />
      )

    case WorkingStepType.Rolling:
      return <Rolling {...getAttributes(props, ref, WorkingStepType.Rolling)} />

    case WorkingStepType.StudWelding:
      return (
        <StudWelding
          {...getAttributes(props, ref, WorkingStepType.StudWelding)}
        />
      )

    case WorkingStepType.TubeProfileOrBarBending:
      return (
        <TubeBending
          {...getAttributes(
            props,
            ref,
            WorkingStepType.TubeProfileOrBarBending
          )}
        />
      )

    case WorkingStepType.Welding:
      return <Welding {...getAttributes(props, ref, WorkingStepType.Welding)} />

    case WorkingStepType.ZincPlating:
      return (
        <ZincPlating
          {...getAttributes(props, ref, WorkingStepType.ZincPlating)}
        />
      )
    case WorkingStepType.Designing:
      return (
        <DrawingIcon
          {...getAttributes(props, ref, WorkingStepType.Designing)}
        />
      )
    case WorkingStepType.Certifying:
      return (
        <CertifyIcon
          {...getAttributes(props, ref, WorkingStepType.Certifying)}
        />
      )
    case WorkingStepType.Shipping:
      return (
        <TransportIcon
          {...getAttributes(props, ref, WorkingStepType.Shipping)}
        />
      )
    case WorkingStepType.Programming:
      return (
        <ProgrammingIcon
          {...getAttributes(props, ref, WorkingStepType.Programming)}
        />
      )
    case WorkingStepType.OrderPicking:
      return (
        <OrderPickingIcon
          {...getAttributes(props, ref, WorkingStepType.OrderPicking)}
        />
      )
    case WorkingStepType.Packaging:
      return (
        <PackagingIcon
          {...getAttributes(props, ref, WorkingStepType.Packaging)}
        />
      )
    case WorkingStepType.BeadBlasting:
      return (
        <BlastingIcon
          {...getAttributes(props, ref, WorkingStepType.BeadBlasting)}
        />
      )
    case WorkingStepType.SandBlasting:
      return (
        <BlastingIcon
          {...getAttributes(props, ref, WorkingStepType.SandBlasting)}
        />
      )
    case WorkingStepType.SteelGridBlasting:
      return (
        <BlastingIcon
          {...getAttributes(props, ref, WorkingStepType.SteelGridBlasting)}
        />
      )
    case WorkingStepType.WetBlasting:
      return (
        <BlastingIcon
          {...getAttributes(props, ref, WorkingStepType.WetBlasting)}
        />
      )
    case WorkingStepType.VacuumBlasting:
      return (
        <BlastingIcon
          {...getAttributes(props, ref, WorkingStepType.VacuumBlasting)}
        />
      )
    case WorkingStepType.CentrifugalBlasting:
      return (
        <BlastingIcon
          {...getAttributes(props, ref, WorkingStepType.CentrifugalBlasting)}
        />
      )
    case WorkingStepType.SodaBlasting:
      return (
        <BlastingIcon
          {...getAttributes(props, ref, WorkingStepType.SodaBlasting)}
        />
      )
    case WorkingStepType.BristleBlasting:
      return (
        <BlastingIcon
          {...getAttributes(props, ref, WorkingStepType.BristleBlasting)}
        />
      )
    case WorkingStepType.DryIceBlasting:
      return (
        <BlastingIcon
          {...getAttributes(props, ref, WorkingStepType.DryIceBlasting)}
        />
      )
    case WorkingStepType.PencilBlasting:
      return (
        <BlastingIcon
          {...getAttributes(props, ref, WorkingStepType.PencilBlasting)}
        />
      )
    case WorkingStepType.WeldGrinding:
      return (
        <WeldGrindingIcon
          {...getAttributes(props, ref, WorkingStepType.WeldGrinding)}
        />
      )
    case WorkingStepType.DieSinking:
      return (
        <DieSinkingIcon
          {...getAttributes(props, ref, WorkingStepType.DieSinking)}
        />
      )
    case WorkingStepType.Nitriding:
      return (
        <NitridingIcon
          {...getAttributes(props, ref, WorkingStepType.Nitriding)}
        />
      )
    case WorkingStepType.RobotStudWelding:
      return (
        <RobotStudWeldingIcon
          {...getAttributes(props, ref, WorkingStepType.RobotStudWelding)}
        />
      )
    case WorkingStepType.RobotWelding:
      return (
        <RobotWeldingIcon
          {...getAttributes(props, ref, WorkingStepType.RobotWelding)}
        />
      )
    case WorkingStepType.WireErosion:
      return (
        <WireErosionIcon
          {...getAttributes(props, ref, WorkingStepType.WireErosion)}
        />
      )
    case WorkingStepType.Hemming:
      return (
        <HemmingIcon {...getAttributes(props, ref, WorkingStepType.Hemming)} />
      )
    case WorkingStepType.Cleaning:
      return (
        <CleaningIcon
          {...getAttributes(props, ref, WorkingStepType.Cleaning)}
        />
      )
    case WorkingStepType.CathodicDipCoating:
      return (
        <DipCoatingIcon
          {...getAttributes(props, ref, WorkingStepType.CathodicDipCoating)}
        />
      )
    case WorkingStepType.ElectrophoreticDipCoating:
      return (
        <DipCoatingIcon
          {...getAttributes(
            props,
            ref,
            WorkingStepType.ElectrophoreticDipCoating
          )}
        />
      )
    case WorkingStepType.FlowDrilling:
      return (
        <FlowDrillingIcon
          {...getAttributes(props, ref, WorkingStepType.FlowDrilling)}
        />
      )
    case WorkingStepType.Foiling:
      return (
        <FoilingIcon {...getAttributes(props, ref, WorkingStepType.Foiling)} />
      )
    case WorkingStepType.HoleProtectioning:
      return (
        <HoleProtectioningIcon
          {...getAttributes(props, ref, WorkingStepType.HoleProtectioning)}
        />
      )
    case WorkingStepType.Operating:
      return (
        <OperatingIcon
          {...getAttributes(props, ref, WorkingStepType.Operating)}
        />
      )
    case WorkingStepType.QualityControlling:
      return (
        <QualityControllingIcon
          {...getAttributes(props, ref, WorkingStepType.QualityControlling)}
        />
      )
    case WorkingStepType.Researching:
      return (
        <ResearchingIcon
          {...getAttributes(props, ref, WorkingStepType.Researching)}
        />
      )
    case WorkingStepType.VibratoryDeburring:
      return (
        <VibratoryDeburringIcon
          {...getAttributes(props, ref, WorkingStepType.VibratoryDeburring)}
        />
      )
    default: {
      return (
        <UndefinedIcon
          {...getAttributes(props, ref, WorkingStepType.NotInitialized)}
          title={props.workingStepType}
        />
      )
    }
  }
}

const WorkingStepIconSvg = React.forwardRef(_WorkingStepIconSvg)

export { WorkingStepIconSvg }
